

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BaraemQuestionHeading from './BaraemQuestionHeading';
import ChildAccordion from './childAccordion';

const BaraemQuestionStep1 = ({
  setQuestionStep, questions, responses, setResponses, baraemUsername, hcNumber, questionnaireid,
  startingIndex, stepSummary, updateStepSummary, questionnaire, age, translationMap
}) => {
  const navigate = useNavigate();
  const [isContinueEnabled, setIsContinueEnabled] = useState(false);
  const [validationErrors, setValidationErrors] = useState({}); // Stores validation errors

  const handleResponseChange = (questionId, answer, questionText, question_i18n, category) => {
    setResponses((prevResponses) => {
      const existingResponse = prevResponses[questionId] || {};
      const updatedResponses = {
        ...prevResponses,
        [questionId]: {
          answer,
          answertext: answer === 'Yes' ? existingResponse.answertext || '' : '',
          questiontext: questionText,
          hasConcern: answer === 'Yes' ? 1 : 0,
          questiontext_i18n: question_i18n || {},
          category: existingResponse.category || category,
          category_i18n: existingResponse.category_i18n || {
            "ar_SA": "عام",
            "en_US": "General"
          }
        }
      };

      validateResponses(updatedResponses);

      return updatedResponses;
    });

  };


  const handleInputChange = (questionId, value) => {
    const cleanedValue = value.replace(/[^A-Za-z\u0600-\u06FF\s]/g, "");

    setResponses((prevResponses) => ({
      ...prevResponses,
      [questionId]: {
        ...prevResponses[questionId],
        answertext: cleanedValue
      }
    }));

    validateResponses({
      ...responses,
      [questionId]: {
        ...responses[questionId],
        answertext: cleanedValue
      }
    });
  };

  const validateResponses = (updatedResponses) => {
    let errors = {};
    let isFormValid = true;

    const numberOfYes = Object.values(updatedResponses).filter((response) => response.answer === 'Yes').length;
    const numberOfNo = Object.values(updatedResponses).filter((response) => response.answer === 'No').length;
    const isPositiveCase = numberOfYes > 0 ? 1 : 0;

    updateStepSummary('General', { numberOfYes, numberOfNo, isPositiveCase });

    for (let question of questions) {
      const response = updatedResponses[question.id];

      if (!response?.answer) {
        isFormValid = false; // Disable continue button if no answer
      }

      if (response?.answer === 'Yes' && !response?.answertext) {
        errors[question.id] = translationMap?.pleaseSpecifyErrorText ?? "Please specify your concern.";
        isFormValid = false;
      }
    }

    setValidationErrors(errors);
    setIsContinueEnabled(isFormValid);
  };

  useEffect(() => {
    window.parent.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    validateResponses(responses);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responses]);



  useEffect(() => {
    const numberOfYes = Object.values(responses).filter((response) => response.answer === 'Yes').length;
    const numberOfNo = Object.values(responses).filter((response) => response.answer === 'No').length;
    const isPositiveCase = numberOfYes > 0 ? 1 : 0;
    updateStepSummary({ numberOfYes, numberOfNo, isPositiveCase });

  }, [responses, updateStepSummary]);

  const generateResponseArray = () => {
    return Object.entries(responses).map(([questionId, response]) => ({
      answer: response.answer,
      answertext: response.answertext || '',
      hasConcern: response.hasConcern || 0,
      hcnumber: hcNumber,
      isactive: 1,
      isFeedback: 0,
      isScheduleAppointment: 0,
      questionid: parseInt(questionId),
      questionnaireid: questionnaireid,
      questiontext: response.questiontext || '',
      questiontext_i18n: response.questiontext_i18n || {},
      category: response.category || "General",
      category_i18n: response.category_i18n || {
        "ar_SA": "أسئلة عامة",
        "en_US": "General"
      }
    }));
  };

  const handleContinue = (event) => {
    event.preventDefault();
    if (isContinueEnabled) {
      const formattedResponses = generateResponseArray();
      // console.log('Formatted Responses:', formattedResponses);

      setResponses((prevResponses) => {
        const updatedResponses = { ...prevResponses };
        formattedResponses.forEach((resp) => {
          updatedResponses[resp.questionid] = resp;
        });
        return updatedResponses;
      });

      setQuestionStep(2);
    }
  };


  if (!questions || questions.length === 0) {
    return <p>Loading questions...</p>;
  }

  return (
    <div>
            <section className="w-100 clearfix BaraemMainSection" style={{ marginTop: "30px" }}>
                <div className="container customContainer">
                    <div className="Title_Inner_Box">
                        <h6 className="MainTitleOne">
                            {translationMap?.childDevAssessment ?? "Child Development Assessment"}
                        </h6>
                    </div>
                    <BaraemQuestionHeading activeStep={1} translationMap={translationMap} setQuestionStep={setQuestionStep} />
                    <div className="cover_inner_wrapper">
                        <div className="cover_main_box1">
                            <div className="baraem_main_inner_wrapper">
                                <form className="form_box form_box_mar_top">
                                    <ChildAccordion
                    childName={baraemUsername}
                    age={age}
                    ageUnit={translationMap?.months ?? "months"}
                    questionnaire={questionnaire}
                    translationMap={translationMap} />

                  
                                    <div className="optimized_welcome_box">
                                        {questions.map((question, index) =>
                    <div className="General_Question_Box" key={question.id}>
                                                <h6 className="question_txt">{`${index + startingIndex} - ${question.question}`}</h6>
                                                <div className="article-question">
                                                    <div className="radio-inline">
                                                        <input
                            className="radio-inline-input"
                            type="radio"
                            name={`inlineRadioOptions${question.id}`}
                            id={`inlineRadioNo${question.id}`}
                            value="No"
                            checked={responses[question.id]?.answer === 'No'}
                            onChange={() =>
                            handleResponseChange(question.id, 'No', question.question, question.question_i18n)
                            } />
                          
                                                        <label className="radio-inline-label" htmlFor={`inlineRadioNo${question.id}`}>
                                                            {translationMap?.no ?? "No"}
                                                        </label>
                                                    </div>
                                                    <div className="radio-inline">
                                                        <input
                            className="radio-inline-input"
                            type="radio"
                            name={`inlineRadioOptions${question.id}`}
                            id={`inlineRadioYes${question.id}`}
                            value="Yes"
                            checked={responses[question.id]?.answer === 'Yes'}
                            onChange={() =>
                            handleResponseChange(question.id, 'Yes', question.question, question.question_i18n)
                            } />
                          
                                                        <label className="radio-inline-label" htmlFor={`inlineRadioYes${question.id}`}>
                                                            {translationMap?.yes ?? "Yes"}
                                                        </label>
                                                    </div>
                                                </div>
                                                {responses[question.id]?.answer === 'Yes' &&
                      <div className="textbox_message inputbox12">
                                                        <input
                          type="text"
                          className="textbox form-control"
                          placeholder={translationMap?.pleaseSpecify ?? "Please specify"}
                          maxLength={100}
                          value={responses[question.id]?.answertext || ''}
                          onChange={(e) =>
                          handleInputChange(question.id, e.target.value)
                          } />
                        
                                                        {validationErrors[question.id] &&
                        <p className="error-message" style={{ color: "red", fontSize: "12px" }}>
                                                                {validationErrors[question.id]}
                                                            </p>
                        }
                                                    </div>
                      }
                                            </div>
                    )}
                                    </div>
                                    <div className="Inner_Box">
                                        <div className="form_buton_box">
                                            <span>
                                                <button
                          onClick={handleContinue}
                          disabled={!isContinueEnabled}
                          // className={!isContinueEnabled ? "disabled_btn_link" : "blue_btn_link"}
                          className={"step1 " + (!isContinueEnabled ? "disabled_btn_link" : "blue_btn_link")}>
                          
                                                    {translationMap?.continue ?? "Continue"}
                                                </button>
                                            </span>
                                            <span>
                                                <button type="button" onClick={() => navigate("/")} className="bluetrans_btn_link">
                                                    {translationMap?.back ?? "Back"}
                                                </button>
                                            </span>
                                            <span>
                                                <button onClick={() => navigate("/")} className="Orangetrans_btn_link">
                                                    {translationMap?.cancel ?? "Cancel"}
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="cover_main_box2"></div>
                    </div>
                </div>
            </section>
        </div>);

};

export default BaraemQuestionStep1;